module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Substract-32f16d34f700536ee02ef450143b886d.svg";